import defaultImage from "../../assets/empty-favorites.png";

// Funzione per ottenere l'immagine per i bookmarks/favoriti
const getBookmarksImagePath = () => {
  const envImage = import.meta.env.VITE_APP_IMAGE_FAVORITES;
  if (envImage) {
    try {
      return new URL(`../../assets/${envImage}`, import.meta.url).href;
    } catch {
      return defaultImage;
    }
  }
  return defaultImage;
};

// Funzione per ottenere l'immagine per la homepage "for you"
const getForYouImagePath = () => {
  const envImage = import.meta.env.VITE_APP_IMAGE_FORYOU_EMPTY;
  if (envImage) {
    try {
      return new URL(`../../assets/${envImage}`, import.meta.url).href;
    } catch {
      return defaultImage;
    }
  }
  return defaultImage;
};

const bookmarksImage = getBookmarksImagePath();
const forYouImage = getForYouImagePath();

/* eslint-disable max-len */
export const Default = {
  coverPublicURL: bookmarksImage,
  shortDescription: "contents_explore",
  title: "favourites_empty"
};

export const HeroCardBookmarkVariants = {
  $topImageVisible: true,
  coverPublicURL: bookmarksImage,
  shortDescription: "contents_explore",
  title: "favourites_empty"
};

export const HeroCardHomeVariants = {
  $topImageVisible: true,
  coverPublicURL: forYouImage,
  shortDescription: "homepage_empty_description",
  title: "homepage_empty"
};

/* eslint-enable max-len */
